import { BASE_WEB_ENDPOINT} from '../admin/api/config';

const BASE_CERTIFICADOS_ENDPOINT = BASE_WEB_ENDPOINT + '/certificados';

export default {
  criar(data) {
    return axios.post(`${BASE_CERTIFICADOS_ENDPOINT}`, data);
  },
  deletar(idCertificado) {
    return axios.delete(`${BASE_CERTIFICADOS_ENDPOINT}/${idCertificado}`);
  },
  adicionarMetodoAutenticacao(idCertificado, data) {
    return axios.post(`${BASE_CERTIFICADOS_ENDPOINT}/${idCertificado}/metodos-autenticacao`, data);
  },
  deletarMetodoAutenticacao(idCertificado, origemTribunalSistemaIds) {
    return axios.delete(`${BASE_CERTIFICADOS_ENDPOINT}/${idCertificado}/metodos-autenticacao`,
      { data: { origem_tribunal_sistema_ids: origemTribunalSistemaIds } });
  },
}
